import React, { Fragment } from 'react';
import Navbar from 'components/@layout/NavBar';
import AppBar from 'components/@layout/AppBar';
import { useTranslation } from 'react-i18next';
import { ModuleProps } from 'types';
import WithPrivilegedUser from 'components/@layout/WithPrivilegedUser';
import Config from 'config';

import ViewControl from 'components/@common/ViewControl';
import AddCreateButton from 'components/@common/Buttons/AddCreateButton';

const { privilegesGroups } = Config;

interface HeaderBarProps {
  onAddClick: VoidFunction;
}

type Props = ModuleProps & HeaderBarProps;

export const HeaderBar: React.FC<Props> = ({ onAddClick, ...props }) => {
  const { t } = useTranslation(props.id);

  return (
    <Fragment>
      <AppBar {...props}>
        <WithPrivilegedUser privileges={privilegesGroups.createUser}>
          <AddCreateButton onClick={onAddClick}>{t('Invite User')}</AddCreateButton>
        </WithPrivilegedUser>
      </AppBar>
      <Navbar {...props}>
        <ViewControl />
      </Navbar>
    </Fragment>
  );
};

export default HeaderBar;
